import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    sortby: 'nameItem',
    sortdir: 'ASC',
    s: undefined,
  },
  details: null,
  findoraItems: [],
  loading: false,
}

export const syncDataListSlice = createAppSlice({
  name: 'syncDataList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setFindoraItems: create.reducer((state, { payload }) => {
      state.findoraItems = payload
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
  }),
})

export const { setFetchOption, setFindoraItems, setLoading } =
  syncDataListSlice.actions

export default syncDataListSlice.reducer
